import { css } from '@emotion/react';

import { theme } from 'global';

export const ordersTable = (expiresSoonExplainerVisible) => css`
  min-height: calc(100vh - ${expiresSoonExplainerVisible ? 445 : 345}px);
  max-height: calc(100vh - ${expiresSoonExplainerVisible ? 445 : 345}px);

  @media screen and (max-width: ${theme.breaks.lg - 1}px) {
    min-height: calc(100vh - ${expiresSoonExplainerVisible ? 425 : 313}px);
    max-height: calc(100vh - ${expiresSoonExplainerVisible ? 425 : 313}px);
  }

  @media screen and (max-width: ${theme.breaks.sm}px) {
    max-height: unset;
    min-height: unset;
  }
`;
